import { PillButton } from "@/components/ui/buttons/PillButton";
import { memo } from "react";

interface ShopListAisleTabsProps {
  aisles: string[];
  selectedAisle: string | null;
  groupedIngredients: Map<string, unknown[]>;
  onSelect: (aisle: string) => void;
}

/**
 * Horizontally scrollable row of aisle filter tabs.
 * Each pill is 38px tall to match the Figma spec.
 */
export const ShopListAisleTabs = memo(function ShopListAisleTabs({
  aisles,
  selectedAisle,
  groupedIngredients,
  onSelect,
}: ShopListAisleTabsProps) {
  return (
    <div className="no-scrollbar flex flex-shrink-0 flex-row items-center gap-2 overflow-x-auto px-4 pt-2 pb-9">
      {aisles.map((aisle) => {
        const count = groupedIngredients.get(aisle)?.length ?? 0;
        return (
          <PillButton
            key={aisle}
            selected={selectedAisle === aisle}
            onClick={() => onSelect(aisle)}
            /* 38px height + standard horizontal padding */
            className="h-[38px] flex-shrink-0 px-4 text-sm"
          >
            {aisle}&nbsp;{count}
          </PillButton>
        );
      })}
    </div>
  );
});
